import React, { useState, useRef, useEffect } from 'react';
import './UI.css';

/**
 * CollapsibleSection - Progressive Disclosure Component
 *
 * Implements the "show headline + 1-sentence summary, click to expand" pattern
 * Perfect for mobile where vertical space is precious
 */
const CollapsibleSection = ({
  title,
  summary,
  children,
  defaultExpanded = false,
  icon = null,
  variant = 'default' // 'default', 'card', 'minimal'
}) => {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded);
  const [height, setHeight] = useState(defaultExpanded ? 'auto' : 0);
  const contentRef = useRef(null);

  useEffect(() => {
    if (isExpanded) {
      setHeight(contentRef.current.scrollHeight);
    } else {
      setHeight(0);
    }
  }, [isExpanded]);

  const toggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div className={`collapsible-section collapsible-${variant}`}>
      <button
        className="collapsible-header"
        onClick={toggleExpanded}
        aria-expanded={isExpanded}
      >
        <div className="collapsible-header-content">
          {icon && <span className="collapsible-icon">{icon}</span>}
          <div className="collapsible-title-group">
            <h3 className="collapsible-title">{title}</h3>
            {summary && !isExpanded && (
              <p className="collapsible-summary">{summary}</p>
            )}
          </div>
        </div>
        <span className={`collapsible-toggle ${isExpanded ? 'expanded' : ''}`}>
          {isExpanded ? '−' : '+'}
        </span>
      </button>

      <div
        className="collapsible-content"
        ref={contentRef}
        style={{
          height: isExpanded ? `${height}px` : '0px',
          opacity: isExpanded ? 1 : 0
        }}
      >
        <div className="collapsible-content-inner">
          {children}
        </div>
      </div>

      {!isExpanded && (
        <button
          className="read-more-link"
          onClick={toggleExpanded}
        >
          Read more →
        </button>
      )}
    </div>
  );
};

export default CollapsibleSection;
